import { CASE_STUDIES, IMPACT_METRICS } from "@/content";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CaseStudiesPage() {
  return (
    <div data-testid="case-studies-page">
      <section className="mx-auto max-w-[1440px] px-6 lg:px-10 pt-16 pb-14">
        <span className="eyebrow">Case Studies</span>
        <h1 className="mt-4 text-4xl lg:text-6xl tracking-[-0.03em] font-semibold text-slate-900 leading-[1.02] max-w-4xl">
          Interventions that moved <span className="text-slate-500">the P&L.</span>
        </h1>
      </section>

      {/* KPI ribbon */}
      <section className="border-y border-slate-200 bg-slate-50">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-10 py-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-6">
          {IMPACT_METRICS.map((m, i) => (
            <div key={i} data-testid={`ribbon-${i}`}>
              <div className="number-hero text-xl lg:text-2xl text-slate-900">{m.value}</div>
              <div className="text-xs text-slate-500 mt-1 leading-tight">{m.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Case studies */}
      <section className="mx-auto max-w-[1440px] px-6 lg:px-10 py-20 space-y-8">
        {CASE_STUDIES.map((cs, idx) => (
          <article
            key={cs.id}
            data-testid={`case-${cs.id}`}
            className="ind-card p-8 lg:p-10 grid grid-cols-1 lg:grid-cols-12 gap-8"
          >
            <div className="lg:col-span-3 flex flex-col justify-between">
              <div>
                <div className="text-[11px] tracking-[0.22em] uppercase text-slate-500">Case {String(idx + 1).padStart(2, "0")}</div>
                <div className="mt-2 text-lg font-semibold text-slate-900">{cs.industry}</div>
                <div className="mt-1 text-sm text-slate-500">{cs.role}</div>
              </div>
              <div className="mt-6 space-y-3">
                {cs.outcomes.map((o, i) => (
                  <div key={i} className="border-l-2 border-[#712ae2] pl-4">
                    <div className="text-[11px] tracking-[0.18em] uppercase text-slate-500">{o.k}</div>
                    <div className="number-hero text-base text-slate-900">{o.v}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:col-span-9">
              <div className="text-[11px] tracking-[0.22em] uppercase text-slate-500">The Challenge</div>
              <p className="mt-2 text-[16px] text-slate-800 leading-relaxed">{cs.challenge}</p>

              <div className="mt-6 text-[11px] tracking-[0.22em] uppercase text-slate-500">The Intervention</div>
              <ul className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2 text-[15px] text-slate-700 leading-relaxed">
                {cs.intervention.map((step, i) => (
                  <li key={i} className="flex gap-2">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-slate-900 shrink-0" />
                    <span>{step}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 rounded-lg bg-amber-50 border border-amber-200 px-4 py-3 text-[14px] text-amber-900">
                <span className="font-semibold">Trade-off disclosed: </span>{cs.tradeoff}
              </div>
            </div>
          </article>
        ))}
      </section>

      <section className="mx-auto max-w-[1440px] px-6 lg:px-10 pb-20">
        <div className="rounded-2xl bg-[#0F172A] text-white p-10 lg:p-14 grid grid-cols-1 lg:grid-cols-12 items-end gap-6">
          <div className="lg:col-span-8">
            <span className="text-[11px] tracking-[0.22em] uppercase text-slate-400">Your Turn</span>
            <h2 className="mt-3 text-3xl lg:text-5xl font-semibold tracking-tight">Same rigour. Your P&L.</h2>
          </div>
          <div className="lg:col-span-4 lg:flex lg:justify-end">
            <Link to="/contact" data-testid="cases-cta" className="inline-flex items-center gap-2 rounded-full bg-white text-slate-900 text-sm font-semibold px-6 py-3">
              Book working session <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
